import React from 'react';
import { InputNumber, Segmented, Select, Space } from 'antd';

import { PAGE_SIZES, setPage } from './pageLayoutModel';

/**
 * The sheet's paper, on a layout with no form: a change to the working copy like
 * any other, so it is a step and goes with the next Save. A form sets its own
 * paper (PageFormPanel), and these wait while a form is on its way.
 */
export default function PagePaperControls({ page, disabled, change }) {
	return (
		<>
		<div className="micro-label page-editor__side-heading">Paper</div>
		<Select
			value={page.size}
			onChange={value => change(latest => setPage(latest, { size: value }), 'paper change')}
			aria-label="Page size"
			disabled={disabled}
			options={[...Object.keys(PAGE_SIZES).map(key => ({ value: key, label: key })), { value: 'custom', label: 'custom' }]}
		/>
		<Segmented
			block
			aria-label="Page orientation"
			disabled={disabled}
			value={page.orientation}
			onChange={value => change(latest => setPage(latest, { orientation: value }), 'paper change')}
			options={[{ value: 'portrait', label: 'Portrait' }, { value: 'landscape', label: 'Landscape' }]}
		/>
		<Space>
			<InputNumber
				value={page.width}
				onChange={value => change(latest => setPage(latest, { size: 'custom', width: value || 1 }), 'paper change', 'page-width')}
				aria-label="Page width"
				disabled={disabled}
				step={0.25}
				min={1}
			/>
			<InputNumber
				value={page.height}
				onChange={value => change(latest => setPage(latest, { size: 'custom', height: value || 1 }), 'paper change', 'page-height')}
				aria-label="Page height"
				disabled={disabled}
				step={0.25}
				min={1}
			/>
			<span className="page-editor__unit">{page.unit}</span>
		</Space>
		</>
	);
}
